import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { ICollectionsState } from ".";

export interface ICompleteCollectionResponse {
    result: boolean;
    exp: number;
    collectionId: number;
};

export const completeCollection = createAsyncThunk<ICompleteCollectionResponse, number>(
    'completeCollection',
    async (collectionId: number) => await api.collections.complete(collectionId)
);

const completeCollectionHandler = (builder: ActionReducerMapBuilder<ICollectionsState>) => {
    builder
        .addCase(completeCollection.pending, (state: ICollectionsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(completeCollection.fulfilled, (state: ICollectionsState, action: PayloadAction<ICompleteCollectionResponse>) => {
            state.loading = false;
            const newItems = state.items.map(collection => {
                if (collection.collectionId !== action.payload?.collectionId)
                    return collection;
                collection.items = [];
                return collection;
            });
            state.items = newItems;
        })
        .addCase(completeCollection.rejected, (state: ICollectionsState) => {
            state.loading = false;
            state.error = 'Unable to complete collection';
        });
};

export default completeCollectionHandler;